module.exports = __webpack_public_path__ + "static/media/AurelionSol.8e059090.png";